const READING_MAX_HEIGHT = 290;

document.addEventListener('DOMContentLoaded', () => {
    const $cappedElements = document.querySelectorAll('.reading-cap:not(.reading-cap-vue)');
    $cappedElements.forEach(element => {
        const elementMaxHeight = element.dataset.maxHeight ? parseInt(element.dataset.maxHeight) : READING_MAX_HEIGHT;
        const orgHeight = element.scrollHeight;
        if (orgHeight > elementMaxHeight && element.parentNode.getElementsByClassName('reading-button').length) {
            element.classList.add('is-capped');
            const buttonElement = element.parentNode.getElementsByClassName('reading-button')[0];
            buttonElement.classList.toggle('is-hidden');

            buttonElement.addEventListener('click', () => {
                element.classList.toggle('is-capped');
                element.style.maxHeight = element.classList.contains('is-capped') ? elementMaxHeight + 'px' : orgHeight + 'px';
                if (buttonElement.getElementsByClassName('text').length) {
                    const buttonText = buttonElement.getElementsByClassName('text')[0];
                    buttonText.innerHTML = element.classList.contains('is-capped') ? buttonText.dataset.readMore : buttonText.dataset.readLess;
                }
            });
        }
    });
});